import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const JobOversightTable = ({ jobs, onRefresh }) => {
  const [loading, setLoading] = useState(false);

  const handleUpdateJobStatus = async (jobId, newStatus) => {
    try {
      setLoading(true);
      const { error } = await supabase
        ?.from('jobs')
        ?.update({ status: newStatus })
        ?.eq('id', jobId);

      if (error) throw error;
      
      alert(`Job ${newStatus} successfully`);
      onRefresh?.();
    } catch (err) {
      console.error('Error updating job status:', err);
      alert('Failed to update job status');
    } finally {
      setLoading(false);
    }
  };

  const handleViewJob = (jobId) => {
    window.open(`/job-board?jobId=${jobId}`, '_blank');
  };

  return (
    <div className="bg-card rounded-lg shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Briefcase" size={24} />
          Job Posting Oversight
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Monitor job postings, manage flagged content, and moderate listings
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Job Title
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Category
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Posted By
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Urgency
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Applicants
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {jobs?.map((job) => (
              <tr key={job?.id} className="hover:bg-muted/30 transition-smooth">
                <td className="px-6 py-4">
                  <p className="font-medium text-foreground text-sm">{job?.title}</p>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-accent/10 text-accent capitalize">
                    {job?.category}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <p className="text-sm text-muted-foreground">{job?.user_profiles?.full_name}</p>
                  <p className="text-xs text-muted-foreground">{job?.user_profiles?.email}</p>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    job?.urgency === 'urgent' ? 'bg-destructive/10 text-destructive' :
                    job?.urgency === 'high'? 'bg-warning/10 text-warning' : 'bg-success/10 text-success'
                  }`}>
                    {job?.urgency}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <p className="text-sm text-foreground font-medium">{job?.applicant_count || 0}</p>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    job?.status === 'active' ? 'bg-success/10 text-success' :
                    job?.status === 'paused'? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground'
                  }`}>
                    {job?.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleViewJob(job?.id)}
                      className="p-2 hover:bg-primary/10 rounded-lg transition-smooth"
                      title="View Job"
                    >
                      <Icon name="Eye" size={16} className="text-primary" />
                    </button>
                    <button
                      onClick={() => handleUpdateJobStatus(job?.id, job?.status === 'active' ? 'paused' : 'active')}
                      disabled={loading}
                      className="p-2 hover:bg-warning/10 rounded-lg transition-smooth disabled:opacity-50"
                      title={job?.status === 'active' ? 'Pause Job' : 'Activate Job'}
                    >
                      <Icon name={job?.status === 'active' ? 'Pause' : 'Play'} size={16} className="text-warning" />
                    </button>
                    <button
                      onClick={() => handleUpdateJobStatus(job?.id, 'cancelled')}
                      disabled={loading}
                      className="p-2 hover:bg-destructive/10 rounded-lg transition-smooth disabled:opacity-50"
                      title="Remove Job"
                    >
                      <Icon name="Trash2" size={16} className="text-destructive" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {jobs?.length === 0 && (
        <div className="p-12 text-center">
          <Icon name="Briefcase" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No flagged jobs found</p>
        </div>
      )}
    </div>
  );
};

export default JobOversightTable;